import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit, faTimes, faExclamationCircle, faList } from '@fortawesome/free-solid-svg-icons';
import { useToasts } from 'react-toast-notifications';
import { Row, Col, Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { DeleteButton } from '@galop/component-library';
import NumberFormat from 'react-number-format';
import { makeCall } from '../../auth-utils';
import { api, globalErrorHandler } from '../../api/create-api';
import { GetOptionText } from '../../Helpers/Helper';
import Can from '../Shared/Can';
import Lock from '../Shared/Lock';

export const Summary = (props) => {
    const { addToast } = useToasts();
    const { resource, showBackground, ReloadResources, Details, ShowDetails, declarationStatuses, eraPrograms, eraStatuses, evictionStatuses, reasons } = props;
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const deleteResource = (resourceId, callback) => {
        makeCall(async (authHeader) => {
            await api.delete(`api/leases/${resourceId}`, {
                headers: authHeader
            })
                .catch(error => globalErrorHandler(error, addToast));

            if (callback && typeof callback === 'function') {
                callback();
            }
        });
    };

    const toggleDeleteModal = () => setShowDeleteModal(!showDeleteModal);

    return (
        <div className={`${showBackground && 'bg-light'} ${resource.deleted ? 'my-1 scrollable-list text-dark' : null} rounded p-2`}>
            <Modal isOpen={showDeleteModal} toggle={toggleDeleteModal}>
                <ModalBody>
                    Are you sure you want to delete this record?
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={() => {
                        deleteResource(resource.id, () => ReloadResources());
                        setShowDeleteModal(!showDeleteModal);
                    }}>Yes</Button>
                    <Button color="light" className="border" onClick={toggleDeleteModal}>No</Button>
                </ModalFooter>
            </Modal>
            <Row className="align-items-center">
                <Col md="6" lg="4">
                    <span className="h4">{resource.residentName}</span> <span className="text-dark">{resource.unit} {resource.leaseId ? <span>(#{resource.leaseId})</span> : null}</span>
                </Col>
                <Col sm="2" lg="1" className="px-3 px-sm-0">
                    {resource.residentStatus}
                </Col>
                <Col>
                    {GetOptionText(evictionStatuses, resource.evictionStatusId, 'id', 'name')}
                </Col>
                <Col sm="2" lg="1" className="px-3 px-md-0">
                    {resource.eraPrograms && !!resource.eraPrograms.find(p => !!(eraPrograms || []).find(era => era.deleted && era.id === p.eraProgramId)) ? <span className="h5"><FontAwesomeIcon className="text-warning" icon={faExclamationCircle} /> </span> : null}{resource.eraPrograms && resource.eraPrograms.filter(program => !!program.eraStatusId).length > 0 ? 'Yes' : 'No'}
                </Col>
                <Col>
                    {GetOptionText(declarationStatuses, resource.declarationStatusId, 'id', 'name')}
                </Col>
                <Col sm="3" md="12" lg="2" className="text-right">
                    <Lock
                        locked={() =>
                            <Button color="secondary" size="sm" outline className={`mr-1`} onClick={ShowDetails}><FontAwesomeIcon icon={faList} /><span className="d-sm-none d-md-inline d-lg-none d-xl-inline"> View</span></Button>
                        }
                        unlocked={() =>
                            <div>
                                <Button color="secondary" size="sm" outline className={`mr-1`} onClick={ShowDetails}><FontAwesomeIcon icon={faEdit} /><span className="d-sm-none d-md-inline d-lg-none d-xl-inline"> Edit</span></Button>
                                {!resource.deleted ?
                                    <Button color="danger" size="sm" outline onClick={toggleDeleteModal}><FontAwesomeIcon icon={faTimes} /><span className="d-sm-none d-md-inline d-lg-none d-xl-inline"> Delete</span></Button>
                                    :
                                    <Can role="admin"
                                        yes={() => <DeleteButton color="secondary" size="sm" outline Close={() => deleteResource(resource.id, () => ReloadResources())}>Recover</DeleteButton>
                                        }
                                    />
                                }
                            </div>
                        }
                    />
                </Col>
            </Row>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/LeaseDetails/Summary.js